/*
 * @Author: yanggqm
 * @Date: 2018-07-16 10:38:40
 * @Last Modified by: yanggqm
 * @Last Modified time: 2018-07-16 11:29:01
 */

import React, { Component } from 'react';
import classnames from "classnames";
import PropTypes from "prop-types";
import Popover from '../Popover';
import Switch from '../Switch';
import { isArrowKeyDown } from '@platform/api';

require('./index.less');

const propTypes = {
    clsPrefix: PropTypes.string,
    disabled: PropTypes.bool,
    checkedChildren: PropTypes.any,
    unCheckedChildren: PropTypes.any,
    onChangeHandler: PropTypes.func,
    onChange: PropTypes.func,
};
const defaultProps = {
    clsPrefix: "wui-switch",
    checkedChildren: null,
    unCheckedChildren: null,
    defaultChecked: false,
    size: "sm",
    disabled: false,
    onChangeHandler: function () { },
    onChange: function () { },
};

class TableSwitch extends Component {
    constructor(props) {
        super(props);
        let checked = false;
        if ('checked' in props) {
            checked = !!props.checked;
        } else if ('defaultValue' in props) {
            checked = !!props.defaultValue;
        } else {
            checked = !!props.defaultChecked;
        }
        this.state = {
            checked,
            content: "",
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        if ("checked" in nextProps) {
            this.setState({ checked: !!nextProps.checked });
        }
    }

    componentDidMount() {
        // 做下自動聚焦
        let { autoFocus, itemtype } = this.props;
        if (autoFocus && this.node && itemtype === 'switch') {
            let elem = this.node; // 获取到底层的input
            elem && elem.focus();
        }
    }

    componentDidUpdate() {
        // 做下自動聚焦
        let { autoFocus, itemtype } = this.props;
        if (autoFocus && this.node && itemtype === 'switch') {
            let elem = this.node; // 获取到底层的input
            elem && elem.focus();
        }
    }

    setChecked = checked => {
        if (this.props.disabled) {
            return;
        }
        if (!('checked' in this.props)) {
            this.setState({ checked });
        }
        this.props.onChangeHandler(checked);
        this.props.onChange(checked);
    }

    //点击switch改变状态
    clickHandler = () => {
        const checked = !this.state.checked;
        this.show(checked);
        // console.log(checked, '&&')
        this.setChecked(checked);
    };

    handleKeyDown = e => {
        let { onEnter, hotKeyWithArrow, renderInTable } = this.props;
        // 添加onkeydown回调  bbqin
        let onKeyDown = this.props.onKeyDown || (() => false);

        //由于跟表格中的左右键冲突所以在表格中渲染switch时阻止内部switch的快捷键逻辑
        if (e.keyCode === 37 && !renderInTable) { // Left
            this.setChecked(false);
            onKeyDown(false, e);
        } else if (e.keyCode === 39 && !renderInTable) { // Right
            this.setChecked(true);
            onKeyDown(true, e);
        } else if (e.keyCode === 32) { // Space
            e.stopPropagation();
            e.preventDefault();
            this.clickHandler();
            onKeyDown(!this.state.checked, e);
        } else if (e.keyCode === 13) { // Enter
            onEnter && onEnter({ e });
        }

        if (isArrowKeyDown(e)) {
            hotKeyWithArrow && hotKeyWithArrow({ e, itemType: 'switch' });
        }
    };

    saveNode = node => {
        this.node = node;
    }

    handleBlur = () => {
        const { onBlur } = this.props;
        onBlur && onBlur(this.state.checked);
        // console.log('失去焦点事件', this.state.checked)
    }

    show = v => {
        let content = "已关闭";
        if (v) {
            content = "开启成功";
        }
        this.setState({ content: content });
    }

    render() {
        const {
            checkedChildren,
            unCheckedChildren,
            onChangeHandler,
            size,
            className,
            clsPrefix,
            disabled,
            colors,
            autoFocus,
            showTip,
            itemtype,
            ...others
        } = this.props;
        //获取checked
        const checked = this.state.checked;

        let classes = {
            "ncs-auto-focused": autoFocus && itemtype === 'switch',
        };

        let classNames = classnames(clsPrefix, classes);
        return <Switch
            {...others}
            colors={colors}
            size={size}
            checked={checked}
            autoFocus={autoFocus}
            disabled={disabled}
            ref={this.saveNode}
            onClick={this.clickHandler}
            onKeyDown={this.handleKeyDown}
            onMouseUp={this.handleMouseUp}
            onBlur={this.handleBlur}
            className={classnames(className, classNames)}
            tabIndex={disabled ? -1 : 0}
        />;
    }
}

TableSwitch.propTypes = propTypes;
TableSwitch.defaultProps = defaultProps;
export default TableSwitch;
